export { default } from './Footer';
export type { Props, Props as ClearingFooterProps } from './Footer';
